/* =============================================================================
   PRIME GARAGE SOLUTIONS — UI behaviour
   Header state, mobile menu, FAQ accordion, count-ups, anchor scroll, and a
   demo-only form success state (static preview). No dependencies.
   ========================================================================== */
(function () {
  "use strict";

  var doc = document.documentElement;
  doc.classList.remove("no-js");
  doc.classList.add("js");

  /* ---- Sticky header state ------------------------------------------------ */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 24) header.classList.add("is-stuck");
      else header.classList.remove("is-stuck");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile menu -------------------------------------------------------- */
  var burger = document.querySelector(".burger");
  if (burger) {
    burger.setAttribute("aria-label", "Toggle menu");
    burger.addEventListener("click", function () {
      document.body.classList.toggle("nav-open");
    });
    document.querySelectorAll(".mobile-menu a").forEach(function (a) {
      a.addEventListener("click", function () { document.body.classList.remove("nav-open"); });
    });
  }

  /* ---- Smooth anchor links (works with or without Lenis) ------------------ */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    var id = a.getAttribute("href");
    if (id.length < 2) return;
    a.addEventListener("click", function (e) {
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      document.body.classList.remove("nav-open");
      if (window.__lenis) window.__lenis.scrollTo(target, { offset: -80 });
      else target.scrollIntoView({ behavior: "smooth" });
    });
  });

  /* ---- FAQ accordion ------------------------------------------------------ */
  document.querySelectorAll(".faq-item").forEach(function (item) {
    var q = item.querySelector(".faq-q");
    var a = item.querySelector(".faq-a");
    if (!q || !a) return;
    q.setAttribute("aria-expanded", "false");
    q.addEventListener("click", function () {
      var open = item.classList.toggle("open");
      q.setAttribute("aria-expanded", open ? "true" : "false");
      a.style.height = open ? a.firstElementChild.offsetHeight + "px" : "0px";
    });
  });

  /* ---- Count-ups ---------------------------------------------------------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var suffix = el.getAttribute("data-suffix") || "";
    var prefix = el.getAttribute("data-prefix") || "";
    var decimals = (target % 1 !== 0) ? 1 : 0;
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  } else {
    counters.forEach(function (c) {
      c.textContent = (c.getAttribute("data-prefix") || "") + c.getAttribute("data-count") + (c.getAttribute("data-suffix") || "");
    });
  }

  /* ---- Demo form (static preview only; Shopify uses native contact form) -- */
  document.querySelectorAll("form[data-demo]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var note = document.createElement("div");
      note.className = "form-success";
      note.textContent = "Thanks — this is a preview. On the live site your request is emailed straight to Prime Garage Solutions.";
      form.prepend(note);
      form.querySelector("button[type=submit]").disabled = true;
      note.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });

  /* ---- Current year in footer -------------------------------------------- */
  document.querySelectorAll("[data-year]").forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  /* ---- Membership "Learn more" popup ------------------------------------- */
  var planTriggers = document.querySelectorAll("[data-plan-modal]");
  if (planTriggers.length) {
    var overlay = document.createElement("div");
    overlay.className = "modal-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML =
      '<div class="modal">' +
      '<button class="modal-close" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="modal-body"></div></div>';
    document.body.appendChild(overlay);

    var modalBody = overlay.querySelector(".modal-body");
    var closeBtn = overlay.querySelector(".modal-close");
    var lastFocused = null;

    function openModal(detail) {
      modalBody.innerHTML = detail.innerHTML;
      lastFocused = document.activeElement;
      overlay.classList.add("is-open");
      document.body.classList.add("modal-open");
      closeBtn.focus();
    }
    function closeModal() {
      overlay.classList.remove("is-open");
      document.body.classList.remove("modal-open");
      modalBody.innerHTML = "";
      if (lastFocused) lastFocused.focus();
    }

    planTriggers.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var card = btn.closest(".plan");
        var detail = card && card.querySelector(".plan-detail");
        if (detail) openModal(detail);
      });
    });
    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeModal();
    });
  }

  /* ---- "Text us" SMS → WhatsApp fallback on desktop ---------------------- */
  /* sms: links do nothing on desktops with no messaging app, so on non-touch
     devices we point the button at WhatsApp Web (which does open). Phones keep
     the native SMS behaviour. */
  var isDesktop = !("ontouchstart" in window) && window.matchMedia("(pointer:fine)").matches;
  if (isDesktop) {
    document.querySelectorAll("a[data-sms]").forEach(function (a) {
      var wa = a.getAttribute("data-wa");
      if (wa) {
        a.setAttribute("href", wa);
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener");
      }
    });
  }

  /* ---- "$350 off" discount popup (once per visit) ------------------------ */
  /* Fires after the visitor scrolls past the hero (garage-door animation done).
     Only on pages that have the hero, and only once per browsing session. */
  if (document.querySelector(".garage-door") && !sessionStorage.getItem("pgs_discount_shown")) {
    var dOverlay = document.createElement("div");
    dOverlay.className = "modal-overlay discount-modal";
    dOverlay.setAttribute("role", "dialog");
    dOverlay.setAttribute("aria-modal", "true");
    dOverlay.setAttribute("aria-label", "$350 off your garage door service");
    dOverlay.innerHTML =
      '<div class="modal">' +
      '<button class="modal-close" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="discount-body">' +
      '<span class="discount-eyebrow">Website exclusive</span>' +
      '<div class="discount-amount metal-text">$350 OFF</div>' +
      '<h3 class="discount-title">A new garage door</h3>' +
      '<p>Just mention you found us on the website when you call and we’ll take ' +
      '<strong>$350 off a brand-new garage door</strong> — supplied and installed. ' +
      'Free measure &amp; quote across the GTA.</p>' +
      '<a class="btn btn--block discount-call" href="tel:+16474108374">' +
      '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.4 11.4 0 0 0 3.6.58 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.4 11.4 0 0 0 .58 3.6 1 1 0 0 1-.24 1z"/></svg>' +
      ' Call now &middot; (647) 410-8374</a>' +
      '<button type="button" class="discount-dismiss">Maybe later</button>' +
      '</div></div>';
    document.body.appendChild(dOverlay);

    var dClose = dOverlay.querySelector(".modal-close");
    var dDismiss = dOverlay.querySelector(".discount-dismiss");

    function openDiscount() {
      dOverlay.classList.add("is-open");
      document.body.classList.add("modal-open");
      sessionStorage.setItem("pgs_discount_shown", "1");
      if (dClose) dClose.focus();
    }
    function closeDiscount() {
      dOverlay.classList.remove("is-open");
      document.body.classList.remove("modal-open");
    }

    if (dClose) dClose.addEventListener("click", closeDiscount);
    if (dDismiss) dDismiss.addEventListener("click", closeDiscount);
    dOverlay.addEventListener("click", function (e) {
      if (e.target === dOverlay) closeDiscount();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && dOverlay.classList.contains("is-open")) closeDiscount();
    });

    var onDiscountScroll = function () {
      if (window.scrollY > window.innerHeight * 0.9) {
        window.removeEventListener("scroll", onDiscountScroll);
        openDiscount();
      }
    };
    window.addEventListener("scroll", onDiscountScroll, { passive: true });
  }
})();
